import clsx from 'clsx';
import { RefObject, KeyboardEvent } from 'react';

type DateRadioOptionProps = {
  isChecked: boolean;
  name: string;
  onChange: () => void;
  onClick: () => void;
  ariaLabel: string;
  radioInputValue: string;
  label?: string;
  className?: string;
  dateRadioRef?: RefObject<HTMLDivElement>;
};

export const DateRadioOption = ({
  dateRadioRef,
  label,
  name,
  isChecked,
  onChange,
  onClick,
  ariaLabel,
  radioInputValue,
  className,
}: DateRadioOptionProps) => {
  const handleArrowDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'ArrowDown') {
      // wait for calendar to open
      setTimeout(() => {
        const calendar: HTMLElement | null =
          document.querySelector('.calendarIsOpen');
        const calendarCloseIcon: HTMLElement | null | undefined =
          calendar?.querySelector('.close-date-panel-btn');
        calendarCloseIcon?.focus();
      });
    }
  };

  return (
    <div
      className={clsx(className, 'amplify-radio-btn', 'rhythm-radio')}
      ref={dateRadioRef}
    >
      <label>
        <input
          type="radio"
          name={name}
          aria-label={ariaLabel}
          value={radioInputValue}
          checked={isChecked}
          onChange={onChange}
          onClick={onClick}
          onKeyDown={handleArrowDown}
        />
        <div className="faux-input" />
        {label && <span>{label}</span>}
      </label>
    </div>
  );
};
